import React, { useEffect, useState } from "react";

const navItems = [
  { href: "#apropos", label: "À propos" },
  { href: "#cours", label: "Cours" },
  { href: "#medias", label: "Médias" },
  { href: "#coachs", label: "Coachs" },
  { href: "#horaires", label: "Horaires" },
  { href: "#ceintures", label: "Ceintures" },
  { href: "#evenements", label: "Événements" },
  { href: "#tarifs", label: "Tarifs" },
  { href: "#enfants", label: "Enfants" },
  { href: "#inscription", label: "Inscription" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar({ open, setOpen = () => {}, social }) {
  const [shrunk, setShrunk] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  // Shrink on scroll
  useEffect(() => {
	const onScroll = () => setShrunk(window.scrollY > 60);
	window.addEventListener("scroll", onScroll, { passive: true });
	return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Active section tracker
  useEffect(() => {
	const ids = navItems.map((n) => n.href.slice(1));
	const observer = new IntersectionObserver(
	  (entries) => {
		const visible = entries.find((e) => e.isIntersecting);
		if (visible) setActiveSection(visible.target.id);
	  },
	  { rootMargin: "-30% 0px -60% 0px", threshold: 0 }
	);
	ids.forEach((id) => {
	  const el = document.getElementById(id);
	  if (el) observer.observe(el);
	});
	return () => observer.disconnect();
  }, []);

  return (
	<nav className={`navbar ${shrunk ? "shrink" : ""}`}>
	  <div className="nav-inner">
		{/* Brand */}
		<a href="/" className="nav-brand">
		  Wolves<span>.</span>
		</a>

		{/* Links */}
		<ul className={`nav-links ${open ? "open" : ""}`}>
		  {navItems.map((item) => (
			<li key={item.href}>
			  <a
				href={item.href}
				className={activeSection === item.href.slice(1) ? "active" : ""}
				onClick={() => setOpen(false)}
			  >
				{item.label}
			  </a>
			</li>
		  ))}
		  <li className="only-mobile">
			<a href={social?.wa} target="_blank" rel="noreferrer">
			  WhatsApp
			</a>
		  </li>
		</ul>

		{/* Burger */}
		<button
		  aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
		  aria-expanded={open}
		  className={`burger ${open ? "open" : ""}`}
		  onClick={() => setOpen(!open)}
		>
		  <span />
		  <span />
		  <span />
		</button>
	  </div>
	</nav>
  );
}
